import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.issueLicences],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            field: "Tipo de licencia string",
            headerName: getLocalizedString("licenseType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            headerName: getLocalizedString("dateFrom"),
            field: "Fecha desde",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            headerName: getLocalizedString("amountOfDays"),
            field: "Cantidad de días",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            headerName: getLocalizedString("dateEnd"),
            field: "Fecha hasta",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            field: "Fecha desde de aplicación",
            headerName: getLocalizedString("applicationStartDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            field: "Fecha hasta de aplicación",
            headerName: getLocalizedString("endDateOfApplication"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            field: "Unidad diaria string",
            headerName: getLocalizedString("dailyUnit"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            headerName: getLocalizedString("timePerDay"),
            field: "Tiempo por día string",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            field: "Clase string",
            headerName: getLocalizedString("class"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            field: "Fecha de retorno",
            headerName: getLocalizedString("returnDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            field: "Código de licencia",
            headerName: getLocalizedString("licenseCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.issueLicences],
        config: {
            headerName: getLocalizedString("comments"),
            field: "Comentarios",
            filter: "agTextColumnFilter",
        }
    },
]